import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AlumniApplicationComponent } from './pages/alumni-application/alumni-application.component';
import { ThankYouScreenComponent } from './pages/thank-you-screen/thank-you-screen.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import * as int from './auth/winauth-intercepter';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http'; 
import { APP_BASE_HREF } from '@angular/common';
import { AgmCoreModule } from '@agm/core';
import { ServiceModule } from './@services/service.module';
import { SharedComponentModule } from './shared-components/shared-components.module'; 
import { WcuAddressComponent } from './components/wcu-address/wcu-address.component';
import { WcuObjectUtility } from './utilities/object.untility';
import { NgbModule, NgbRadioGroup } from '@ng-bootstrap/ng-bootstrap';
import { GridModule } from '@progress/kendo-angular-grid';
import { FilterPipeModule } from 'ngx-filter-pipe';
import { NbCardModule, NbRadioModule } from '@nebular/theme';
import { OverwriteEntryConfirmationModalComponent } from './pages/alumni-application/confirmation-model/confirmation-model.component';
import { TimesPipe } from './pipes/times.pipe';
import { AlumniQuestionComponent } from './components/alumni-question/alumni-question.component';
import {MatRadioModule} from '@angular/material/radio';
import { CategoryDetailComponent } from './pages/thank-you-screen/departmentgrid/department-list.component';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { BsDatepickerModule, DatepickerModule } from 'ngx-bootstrap/datepicker';
import { Ng2AutoCompleteModule } from 'ng2-auto-complete';
import { OnlynumberDirective } from './directive/number.directive';
import {MatAutocompleteModule} from '@angular/material/autocomplete';


@NgModule({
  declarations: [
    AppComponent,
    AlumniApplicationComponent,
    ThankYouScreenComponent,
    OnlynumberDirective,
    WcuAddressComponent,
    AlumniQuestionComponent,
    CategoryDetailComponent,
    OverwriteEntryConfirmationModalComponent,
    TimesPipe
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    FilterPipeModule,
    MatAutocompleteModule,
    NbRadioModule,
    MatRadioModule,
    NbCardModule,
    DropDownsModule,
    Ng2AutoCompleteModule,
    NgbModule.forRoot(),
    BsDatepickerModule.forRoot(),
    DatepickerModule.forRoot(),
    ServiceModule.forRoot(),
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyDIiv1d0du2yg2BMiprSbGUK1ekxbIy2vk',
      libraries: ["places"]
  }),
    SharedComponentModule,
    GridModule
  ],
  exports:[TimesPipe],
  entryComponents:[OverwriteEntryConfirmationModalComponent],
  providers: [
    { provide: APP_BASE_HREF, useValue: '/' },
    { provide: HTTP_INTERCEPTORS, useClass: int.WinAuthInterceptor, multi: true },
    {provide:WcuObjectUtility}
  ], 
  bootstrap: [AppComponent]
})
export class AppModule { }
